<template>
  <transition name="VERTICAL" mode="out-in">
    <div class="APPOINTMENT-LIST-CONTAINER">
      <div class="p-2 bd-b-gray30 d-flex jc-between ai-center ">
        <span
            class="p-r-2"
            :class="[enablePrev ? 'cur-pointer' : 'c-gray40']"
            @click="prevDay">
          <vk-icon name="chevronleft" class="c-depot"/>
        </span>
        <span class="h5:d text-bold p-r-2">{{ displayDate }}</span>
        <span
            class="cur-pointer"
            :class="[enableNext ? 'cur-pointer' : 'c-gray40']"
            @click="nextDay">
          <vk-icon name="chevronright" class="c-depot"/>
        </span>
      </div>
      <div v-if="dayAppointments.length" class="APPOINTMENT-LIST">
        <day-agenda-list-item
            v-for="(appointment) in dayAppointments"
            :key="appointment"
            :id="appointment"
            class="LIST-ITEM"
            @onDelete="onDelete"
        />
      </div>
      <appointment-list-placeholder v-else/>
    </div>
  </transition>
</template>

<script>
import { isFirstDayOfMonth, isLastDayOfMonth, format } from 'date-fns';
import DayAgendaListItem from './DayAgendaListItem';
import AppointmentListPlaceholder from '../AppointmentList/AppointmentListPlaceholder';

export default {
  name: 'day-agenda-list',
  components: {
    DayAgendaListItem,
    AppointmentListPlaceholder,
  },
  props: {
    dayAppointments: {
      type: Array,
      default: () => [],
    },
    selectedDate: {
      type: [Date, String],
      default: new Date(),
    },
  },
  computed: {
    enableNext () {
      return !isLastDayOfMonth(new Date(this.selectedDate));
    },
    enablePrev () {
      return !isFirstDayOfMonth(new Date(this.selectedDate));
    },
    displayDate () {
      return format(new Date(this.selectedDate), 'MMMM d');
    },
  },
  methods: {
    nextDay () {
      if (this.enableNext) {
        this.$emit('nextDay');
      }
    },
    prevDay () {
      if (this.enablePrev) {
        this.$emit('prevDay');
      }
    },
    onDelete (item) {
      this.$emit('onDelete', item);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/constants";

  .APPOINTMENT-LIST {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: hidden;
  }
  .APPOINTMENT-LIST-CONTAINER {
    @include responsive(border-left, none, 1px solid $color-gray30);
    @include responsive(border-right, none, 1px solid $color-gray30);
    position: relative;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    background-color: white;
    border-top: 1px solid $color-gray30;
    border-bottom: none;
    overflow: auto;
    margin-left: $unit;
  }
  .LIST-ITEM {
    transition: all $transition-duration;
  }
</style>
